// Mock data for appointment slots and services

export const services = [
  {
    id: 1,
    name: '30-minute massage',
    duration: 30,
    price: 55,
    description: 'Quick relief for targeted areas'
  },
  {
    id: 2,
    name: '45-minute massage',
    duration: 45,
    price: 70,
    description: 'Focused relaxation session'
  },
  {
    id: 3,
    name: '60-minute massage',
    duration: 60,
    price: 110,
    description: 'Full body relaxation experience'
  },
  {
    id: 4,
    name: '90-minute massage',
    duration: 90,
    price: 160,
    description: 'Extended therapeutic session'
  },
  {
    id: 5,
    name: '120-minute massage',
    duration: 120,
    price: 200,
    description: 'Ultimate wellness experience'
  }
];

// Generate available time slots for next 30 days
export const generateTimeSlots = () => {
  const slots = [];
  const today = new Date();
  const timeOptions = ['9:00 AM', '10:30 AM', '12:00 PM', '2:00 PM', '3:30 PM', '5:00 PM'];
  
  for (let i = 1; i <= 30; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    
    // Skip Sundays (0) and Mondays (1)
    if (date.getDay() !== 0 && date.getDay() !== 1) {
      timeOptions.forEach(time => {
        slots.push({
          id: `${date.toISOString().split('T')[0]}-${time}`,
          date: date.toISOString().split('T')[0],
          time: time,
          available: Math.random() > 0.3 // 70% slots available
        });
      });
    }
  }
  
  return slots;
};

// Store bookings in localStorage
export const getBookings = () => {
  const bookings = localStorage.getItem('ayumi_bookings');
  return bookings ? JSON.parse(bookings) : [];
};

export const addBooking = (booking) => {
  const bookings = getBookings();
  bookings.push({
    ...booking,
    id: Date.now().toString(),
    createdAt: new Date().toISOString()
  });
  localStorage.setItem('ayumi_bookings', JSON.stringify(bookings));
  return bookings;
};